import MortgageInfo from './MortgageInfo';
export default MortgageInfo;
